import React from 'react'
import { useTranslation } from 'react-i18next';
import {
    AppBar,
    Box,
    colors,
    Link,
    Typography
} from '@mui/material'

const Header2 = ({ logoImgSource, logoAlt = "trekzy.com", logoWidth = 'rem' }) => {
    const { t } = useTranslation(['header']);
    return (
        <Box>
            <AppBar
                sx={{
                    px: { xs: '1%', md: '6%', lg: '8%' },
                    py: '8px',
                    position: 'initial'
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                    <Link href="/">
                        <img
                            alt={logoAlt}
                            src={logoImgSource}
                            style={{
                                width: logoWidth,
                                height: 'auto',
                                paddingTop: '.5rem'
                            }}
                        />
                    </Link>
                    <Link href={`/${t('paths:contact')}`} style={{ color: 'white' }}>
                        <Typography>
                            <b>{t('needHelp')}</b>
                            {/* <b>{t('contact')}</b> */}
                        </Typography>
                    </Link>
                </Box>
            </AppBar >
        </Box >
    )
}

export default Header2
